"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fetchApi_1 = __importDefault(require("../../rest/fetchApi"));
var combinePlatformUrl_1 = __importDefault(require("./combinePlatformUrl"));
var customCoursesApi_1 = require("../mock/customCoursesApi");
var CustomCoursesAPIs = {
    createCustomCourse: function (body) {
        return fetchApi_1.default.post({ mockFunc: customCoursesApi_1.createCustomCourse, url: (0, combinePlatformUrl_1.default)('/api/v2/custom_courses/create'), body: body });
    },
    updateCustomCourse: function (_a) {
        var id = _a.id, body = __rest(_a, ["id"]);
        return fetchApi_1.default.patch({
            mockFunc: customCoursesApi_1.updateCustomCourse,
            url: (0, combinePlatformUrl_1.default)("/api/v2/custom_courses/".concat(id, "/update")),
            body: body,
        });
    },
    getCustomCourseById: function (id) {
        return fetchApi_1.default.get({
            mockFunc: customCoursesApi_1.getCustomCourseById,
            url: (0, combinePlatformUrl_1.default)("/api/v2/custom_courses/fetch_course?id=".concat(id)),
        });
    },
    fetchImages: function () {
        return fetchApi_1.default.get({ mockFunc: customCoursesApi_1.fetchImages, url: (0, combinePlatformUrl_1.default)('/api/v2/custom_courses/fetch_icons') });
    },
    fetchDefaultIcon: function () {
        return fetchApi_1.default.get({
            mockFunc: customCoursesApi_1.fetchDefaultIcon,
            url: (0, combinePlatformUrl_1.default)('/api/v2/custom_courses/fetch_default_icon'),
        });
    },
    fetchAllCustomCourses: function (status) {
        return fetchApi_1.default.get({
            mockFunc: customCoursesApi_1.fetchAllCustomCourses,
            url: (0, combinePlatformUrl_1.default)("/api/v2/custom_courses/fetch_all?status=".concat(status)),
        });
    },
    deleteCustomCourse: function (id) {
        return fetchApi_1.default.delete({
            mockFunc: customCoursesApi_1.deleteCustomCourse,
            url: (0, combinePlatformUrl_1.default)("/api/v2/custom_courses/".concat(id, "/destroy")),
        });
    },
    publishCustomCourse: function (id) {
        return fetchApi_1.default.post({
            mockFunc: customCoursesApi_1.publishCustomCourse,
            url: (0, combinePlatformUrl_1.default)("/api/v2/custom_courses/publish?id=".concat(id)),
        });
    },
    fetchAvailableLessons: function () {
        return fetchApi_1.default.get({
            mockFunc: customCoursesApi_1.fetchAvailableLessons,
            url: (0, combinePlatformUrl_1.default)('/api/v2/custom_courses/fetch_available_lessons'),
        });
    },
};
exports.default = CustomCoursesAPIs;
